import { useState } from 'react';
import API from '../../api';

// redux
import { mapDispatchProps, mapStateToProps } from '../../store/store';
import { connect } from 'react-redux';
import { X } from 'react-feather';
import Button from '../../components/button';
import Divider from '../../components/divider';
import { OverlayBrandTaxInvoiceInfoFormResult } from 'components/overlayBrandTaxInvoiceInfoForm';
import Payment from '../../pages/cards/select';
import { debounce } from '../../helpers/debounce';
import Checkbox, { ICON_TYPES } from '../../components/checkbox';
import { useLanguage } from '@languages/index';
import { useStripe } from '@stripe/react-stripe-js';
import { BRAND_BILLING_TYPES } from 'store/brand/reducer';
import { PAYMENT_PRODUCT_TYPE } from 'constants/payment';

interface PaymentCreatePropTypes {
  summary?: any;

  temporaryKey?: any;
  campaignId?: any;
  productId?: any;
  postingId?: any;

  campaign?: any;
  setCampaign?: (params?: any) => void;

  itemType: any;
  amount: number;
  price: number;
  priceTotal?: number;

  cashCampaignPaymentData?: Pick<
    OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment'], 
    keyof OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment']
  > | null

  brand?: any;
  auth?: any;
  preferences?: any;
  settings?: any;

  onSuccess?: any;

  setPopup?: (params?: any) => void;
  closePopup?: () => void;

  showSheet?: (params?: any) => void;
  closeSheet?: () => void;

  showModal?: (params?: any) => void;
  closeModal?: () => void;

  showOverlays?: (params?: any) => void;
  closeOverlays?: () => void;
}

const PaymentCreate = (props: PaymentCreatePropTypes) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.payments };
  const [isPending, setIsPending] = useState(false);
  const [isAgreed, setIsAgreed] = useState(
    props.itemType == PAYMENT_PRODUCT_TYPE.SEEDING_PASS ? false : true,
  );
  const stripe = useStripe();

  const getProductName = () => {
    let result = '';
    switch (props.itemType) {
      case PAYMENT_PRODUCT_TYPE.SEEDING_FIRST:
        result = languageTexts.create_text_2;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS:
        result = languageTexts.create_text_3;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER:
        result = languageTexts.create_text_4;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING:
        result = languageTexts.create_text_5;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_COMMISSION:
        result = languageTexts.create_text_16;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_VIDEO_CLEAN:
        result = languageTexts.create_text_clean_video_name;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_PASS:
      case PAYMENT_PRODUCT_TYPE.SNS_INSTALL:
        result = languageTexts.create_text_6;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_PASS_RECOVER:
        result = languageTexts.create_text_7;
        break;
    }
    return result;
  };

  const getProductUnitTitle = () => {
    let result = '';
    switch (props.itemType) {
      case PAYMENT_PRODUCT_TYPE.SEEDING_FIRST:
      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS:
      case PAYMENT_PRODUCT_TYPE.SEEDING:
      case PAYMENT_PRODUCT_TYPE.SEEDING_COMMISSION:
      case PAYMENT_PRODUCT_TYPE.SEEDING_VIDEO_CLEAN:
      case PAYMENT_PRODUCT_TYPE.SNS_PASS:
      case PAYMENT_PRODUCT_TYPE.SNS_INSTALL:
        result = languageTexts.create_text_9;
        break;
    }
    return result;
  };

  const renderTitle = () => {
    return (
      <div className="relative flex flex-row items-center md:pt-[40px] pb-[16px]">
        <div className="flex flex-row justify-center items-center">
          <span className="text-xl font-bold text-center md:text-start">
            {languageTexts.pay}
          </span>
        </div>

        <div
          className="cursor-pointer items-center absolute right-0"
          onClick={() => {
            props.closeOverlays();
          }}
        >
          <div>
            <X size={24} strokeWidth={1} />
          </div>
        </div>
      </div>
    );
  };

  const intoKorean = (price: number) => {
    return languageTexts._price_10000(
      price / 10000,
      props.settings.currencyText,
    );
  };

  const renderSummary = () => {
    const background = {
      backgroundColor: 'rgba(255,255,255,0.1)',
    };

    return (
      <>
        <div className="flex flex-col bg-black p-6">
          <div className="flex flex-col p-5" style={background}>
            {props.itemType == PAYMENT_PRODUCT_TYPE.SNS_INSTALL ? (
              <div className="flex flex-row justify-between">
                <div className="flex flex-col justify-center">
                  <span className="font-bold text-[13px] tracking-tighter text-white max-w-[115px]">
                    {props.itemType == PAYMENT_PRODUCT_TYPE.SNS_INSTALL
                      ? languageTexts.complete_text_12
                      : null}
                  </span>
                </div>

                <div className="flex flex-col justify-center gap-1">
                  <span className="font-bold text-[13px] tracking-tighter text-right text-white">
                    {languageTexts._price(
                      props.brand.priceSnsInstall.toLocaleString(),
                      props.settings.currencyText,
                    )}
                  </span>

                  {props.itemType == PAYMENT_PRODUCT_TYPE.SNS_INSTALL ? (
                    <span className="font-bold text-[11px] tracking-tighter text-right text-gray-400">
                      {languageTexts.complete_text_13}
                    </span>
                  ) : null}
                </div>
              </div>
            ) : null}

            <div className="flex flex-row justify-between">
              <div className="flex flex-col justify-center">
                <span className="font-bold text-[13px] tracking-tighter text-white max-w-[115px]">{`${getProductName()} ${getProductUnitTitle()}`}</span>
              </div>

              <div className="flex flex-col justify-center gap-1">
                <span className="font-bold text-[13px] tracking-tighter text-right text-white">
                  {languageTexts._price(
                    (props.price * props.amount).toLocaleString(),
                    props.settings.currencyText,
                  )}
                </span>

                {/* 제품제공 1회용 */}
                {props.itemType == PAYMENT_PRODUCT_TYPE.SEEDING ? (
                  <span className="font-bold text-[11px] tracking-tighter text-right text-gray-400">
                    {languageTexts._complete_text_total_price(
                      intoKorean(props.price),
                      props.amount,
                    )}
                  </span>
                ) : null}

                {/* 제품 제공 자동 결제 복구 */}
                {props.itemType == PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER ? (
                  <span className="font-bold text-[11px] tracking-tighter text-right text-gray-400">
                    {languageTexts._complete_text_14(
                      props.brand.activeSeedingPassEndsAt,
                    )}
                  </span>
                ) : null}

                {/* 동동이 이용권 */}
                {props.itemType == PAYMENT_PRODUCT_TYPE.SNS_INSTALL ||
                props.itemType == PAYMENT_PRODUCT_TYPE.SNS_PASS ? (
                  <span className="font-bold text-[11px] tracking-tighter text-right text-gray-400">
                    {languageTexts._create_text_10(
                      props.settings.durationSnsPass,
                    )}
                  </span>
                ) : null}
              </div>
            </div>

            {props.itemType == PAYMENT_PRODUCT_TYPE.SEEDING_PASS ? (
              <div className="flex flex-row justify-between ml-auto">
                <div className="flex flex-col justify-center gap-1 items-end">
                  <div className="flex flex-col">
                    <span className="font-bold text-[11px] tracking-tighter text-right text-gray-400">
                      {languageTexts._create_text_10(
                        props.settings.durationSeedingPass,
                      )}
                    </span>
                    <span className="font-bold text-[11px] tracking-tighter text-right text-gray-400">
                      {languageTexts._create_text_11()}
                    </span>
                  </div>

                  <Checkbox
                    text={languageTexts.create_text_12}
                    textClassName={'text-white text-[13px] font-normal'}
                    type={ICON_TYPES.DEFAULT_INVERTED}
                    checked={isAgreed}
                    onClick={() => {
                      setIsAgreed(!isAgreed);
                    }}
                  />
                </div>
              </div>
            ) : null}

            <Divider
              style={{ borderColor: 'rgba(255,255,255,0.3)' }}
              className="my-5"
            />

            <div className="flex flex-col gap-2">
              <div className="flex flex-row justify-between">
                <div className="flex flex-col justify-center">
                  <span className="font-bold text-[13px] tracking-tighter text-white">
                    {languageTexts.total_price}
                  </span>
                </div>

                <div className="flex flex-col justify-center gap-1">
                  <span className="font-bold text-[13px] tracking-tighter text-right text-white">
                    {languageTexts._price(
                      props.priceTotal
                        ? Math.round(props.priceTotal).toLocaleString()
                        : Math.round(
                            props.price * props.amount,
                          ).toLocaleString(),
                      props.settings.currencyText,
                    )}
                  </span>
                </div>
              </div>

              <div className="flex flex-row justify-between">
                <div className="flex flex-col justify-start">
                  <span className="text-[11px] tracking-tighter text-white">
                    {languageTexts.complete_text_16}
                  </span>
                </div>

                <div className="flex flex-col justify-center gap-1">
                  <span className="text-[11px] tracking-tighter text-right text-white">
                    {languageTexts._price(
                      props.priceTotal
                        ? Math.round(props.priceTotal * 0.1).toLocaleString()
                        : Math.round(
                            props.price * props.amount * 0.1,
                          ).toLocaleString(),
                      props.settings.currencyText,
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-row justify-between mt-8">
            <span className="font-bold text-base tracking-tighter text-white">
              {languageTexts.complete_text_17}
            </span>
            <span className="font-bold text-base tracking-tighter text-white">
              {languageTexts._price(
                props.priceTotal
                  ? Math.round(props.priceTotal * 1.1).toLocaleString()
                  : Math.round(
                      props.price * props.amount * 1.1,
                    ).toLocaleString(),
                props.settings.currencyText,
              )}
            </span>
          </div>
        </div>
      </>
    );
  };

  const renderProceedPaymentButton = () => {
    const isActiveCardExists = props.brand.cards && props.brand.cards.length;
    const isFreeBrand = props.brand.billingType === BRAND_BILLING_TYPES.FREE;

    let buttonColor = '#919191';
    if ((isFreeBrand || isActiveCardExists) && isAgreed && !isPending)
      buttonColor = 'BLACK';

    const getText = () => {
      if (isPending) return languageTexts.create_text_13;
      if (!isAgreed) return languageTexts.create_text_14;

      return languageTexts.pay;
    };

    return (
      <div className="fixed md:absolute bottom-0 left-0 right-0 form-submit-button">
        {isFreeBrand && (
          <div className="my-[8px] text-center text-[12px] text-[#FF4040] font-bold">
            {languageTexts.create_text_cash_brand_warning}
          </div>
        )}
        <Button
          textColor={'WHITE'}
          buttonColor={buttonColor}
          borderColor={buttonColor}
          text={getText()}
          onClick={
            isPending || !isAgreed
              ? () => {}
              : () => {
                  API.Card.index({
                    ...{
                      brandToken: props.auth.token,
                    },
                  })
                    .then((response) => {
                      const fetchedCards = response.data.cards.data;
                      if (!fetchedCards.length && !isFreeBrand) {
                        props.showModal({ text: languageTexts.create_text_15 });
                        setIsPending(false);
                        return false;
                      }

                      if (isPending) return false;
                      setIsPending(true);

                      debounce(async () => {
                        try {
                          const response = await API.Payment.proceed({
                            temporaryKey: props.temporaryKey,
                            campaignId: props.campaignId,
                            productId: props.productId,
                            itemType: props.itemType,
                            brandToken: props.auth.token,
                            amount: props.amount,
                            price: props.price,
                            priceTotal: props.priceTotal
                              ? Math.round(props.priceTotal * 1.1).toFixed(0)
                              : Math.round(
                                  props.amount * props.price * 1.1,
                                ).toFixed(0),
                            // 이하 현금결제관련
                            taxInvoiceScheduledDate: props.cashCampaignPaymentData?.taxInvoiceScheduledDate,
                            depositScheduledDate: props.cashCampaignPaymentData?.depositScheduledDate,
                          });

                          props.closeOverlays();
                          setTimeout(() => {
                            props.onSuccess
                              ? props.onSuccess({
                                  itemType: props.itemType,
                                  amount: props.amount,
                                  price: props.price,
                                  priceTotal: props.priceTotal,
                                  payment: response.data.payment,
                                })
                              : null;
                          }, 400);

                          setTimeout(() => {
                            setIsPending(false);
                          }, 1000);
                        } catch (paymentResponse) {
                          setIsPending(false);
                          if (paymentResponse.message == 'requires_action') {
                            props.showModal({
                              text: '현재 이용할 수 없는 카드 입니다. 다른 카드를 이용해주세요.',
                            });
                            return false;

                            // const { error, paymentIntent } = await stripe.confirmCardPayment(
                            //   paymentResponse.data.payment_intent_client_secret
                            // )

                            // if (error) {
                            // props.showModal({ text: error.message })
                            //   return
                            // }

                            // The payment requires additional confirmation
                            // const confirmResponse = await fetch("/your-backend-confirm-route", {
                            //   method: "POST",
                            //   headers: {
                            //     "Content-Type": "application/json",
                            //   },
                            //   body: JSON.stringify({ paymentIntentId: paymentIntent.id }),
                            // })

                            // const confirmResult = await confirmResponse.json()

                            // if (confirmResult.error) {
                            //   console.error(confirmResult.error)
                            //   alert("Payment failed: " + confirmResult.error)
                            // } else {
                            //   alert("Payment successful!")
                            // }

                            return false;
                          }

                          props.showModal({ text: paymentResponse.message });
                        }
                      }, 400);
                    })
                    .catch((error) => {
                      setTimeout(() => {
                        setIsPending(false);
                        props.showModal({ text: error.message });
                      }, 400);
                    });
                }
          }
        />
      </div>
    );
  };

  const renderCards = () => {
    return <Payment />;
  };

  let containerStyle = '';
  if (props.preferences.isMobile) {
    containerStyle =
      'h-[100dvh] flex flex-col overflow-scroll bg-white w-[100dvw] px-5 py-5';
  } else {
    containerStyle =
      'relative w-full flex flex-col rounded-2xl overflow-visible  px-10 bg-white pb-[5.5rem] w-[480px]';
  }

  return (
    <>
      <div className={`${containerStyle}`}>
        {renderTitle()}
        {renderSummary()}
        {renderCards()}
        {renderProceedPaymentButton()}
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(PaymentCreate);
